import { FrequentPassageRequest } from '@legacy-types';

import { api } from '@shared/api/api';

export type RedeemFrequentPassageRequestData = {
  code: string;
  internalNote: string | null;
};

export const redeemFrequentPassageRequest = api.createAction<RedeemFrequentPassageRequestData, FrequentPassageRequest>(
  'frequent-passage-requests/:id/redeem'
);
